import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=65220be1&scoped=true"
import script from "./projects.ts?vue&type=script&lang=js&external"
export * from "./projects.ts?vue&type=script&lang=js&external"
import style0 from "./projects.vue?vue&type=style&index=0&id=65220be1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65220be1",
  null
  
)

export default component.exports